import { TableBody, TableHead, TableWrapper } from "./components";
import { TableRow } from "./components/TableRow/TableRow";
import style from "./Table.module.scss";

export function Table() {
    return (
        <div className={style.container}>
            <div data-scrollable="proxy" className={style.scrollBox}>
                <TableWrapper>
                    <TableHead />
                    <TableBody>
                        {(data) => (
                            <TableRow key={data.id} data={data} />
                        )}
                    </TableBody>
                </TableWrapper>
            </div>
        </div>
    )
}